import { render, staticRenderFns } from "./_matchLog.vue?vue&type=template&id=555e6543&scoped=true&lang=pug&"
import script from "./_matchLog.vue?vue&type=script&lang=js&"
export * from "./_matchLog.vue?vue&type=script&lang=js&"
import style0 from "./_matchLog.vue?vue&type=style&index=0&id=555e6543&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555e6543",
  null
  
)

export default component.exports